<template lang="html">
  <div class="alreadyadopted">
    <div class="text-center">
      <v-chip
        class="ma-2"
        color="secondary"
        :class="{chipactive: year==='2019'}"
        @click="showYear('2019')"
      >
        2019
      </v-chip>
      <v-chip
        class="ma-2"
        color="secondary"
        :class="{chipactive: year==='2018'}"
        @click="showYear('2018')"
      >
        2018
      </v-chip>
      <v-chip
        class="ma-2"
        color="secondary"
        :class="{chipactive: year==='all'}"
        @click="showYear('all')"
      >
        Összes év
      </v-chip>

      <div class="osszesito">
        Örökbeadott védencek száma
          <span v-if="year==='all'">összesen: </span>
          <span v-else>a {{year}}. évben: </span>
          <span class="kiemelt">{{animals.length}}&nbsp;védenc</span>
      </div>
      <AnimalList :animals="animals" />
    </div>
  </div>
</template>

<script>
import AnimalList from '@/components/AnimalList.vue'

export default {
  data(){
    return {
      animals: this.$store.getters.allAnimals.filter(a=>a.adopted),
      year: 'all',
    }
  },
  components:{
    AnimalList,
  },
  methods:{
    showYear(year){
      if (year==='all') {
        this.year = 'all';
        this. animals = this.$store.getters.allAnimals.filter(a=>a.adopted)
      }else{
        this.year = year;
        this. animals = this.$store.getters.allAnimals.filter(a=>a.adopted)
        this.animals = this.animals.filter(a=>a.date_of_adoption.split('-')[0]===year)
      }

    }
  }
}
</script>

<style lang="scss" scoped>
.v-chip.chipactive{
  background: $darkbrown !important;
}

.osszesito{
  margin-top: 30px;

  .kiemelt{
    color: $darkbrown;
    font-weight: bold;
  }
}
</style>
